<template>
  <div
    class="xl:text-5.2xl xl:leading-70 lg:h-auto md:text-4xl md:leading-46 md:rtl:h-24.25 text-text-primary-black text-3xl leading-9.5 font-bold rtl:h-21"
    :class="childClass"
  >
    {{ $t(`landingPage.${text}`) }}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    childClass: {
      type: String,
      default: 'sm:text-4.1xl sm:leading-46 ',
    },
  },
  data: function () {
    return {
      landingPage: 'landingPage',
    }
  },
}
</script>
